import React, { Component } from 'react';
import { Example } from 'examples';
import Button from '../Button/Button';
import ModalOptions from './ModalOptions';

const OPTIONS = [{
  name: 'Page 1',
  icon: 'arrow-right'
}, {
  name: 'Asset',
  icon: 'asset'
}, {
  name: 'Carousel',
  icon: 'carousel'
}, {
  name: 'Category',
  icon: 'category'
}, {
  name: 'Contract',
  icon: 'contract'
}, {
  name: 'Movie',
  icon: 'movie'
}];

export default class ModalOptionsExample extends Component {

  state = {};

  onBack = () => this.setState({ active: null });

  onClick = e => {
    const name = e.currentTarget.dataset.name;

    window.showAppInfo(name);
    this.setState({
      active: name,
      open: name === OPTIONS[0].name,
    });
  };

  onClose = () => this.setState({
    active: null,
    open: false,
  });

  onOpen = () => this.setState({ open: true });

  render() {
    const { open, title, active } = this.state;
    const className = active === OPTIONS[0].name ? 'show-custom-content' : '';

    return (
      <Example {...this.props} className="no-props">
        <Button onClick={this.onOpen}>Show modal options</Button>
        {open && (
          <ModalOptions
            className={className}
            onOptionClick={this.onClick}
            onClose={this.onClose}
            options={OPTIONS}
            title={title}>
            <div className="custom-content">
              <h2 className="modal-header">Page 2</h2>
              <div className="buttons">
                <Button className="tertiary" onClick={this.onBack}>Back</Button>
                <Button className="primary" onClick={this.onClose}>Select</Button>
              </div>
            </div>
          </ModalOptions>
        )}
      </Example>
    );
  }

}
